import React from 'react'
import { NavLink } from 'react-router-dom'
import { useViewport } from '../../utils'

const NavItem = ({to, text, icon, className, accent, uppercase, embed, small, exact}) => {
  const accented = accent ? 'font-accent' : ''
  const uppercaseClass = uppercase ? 'uppercase' : ''

  const activeClassName = "border-b-2 lg:border-b-4 opacity-100"

  return (
    <NavLink
      to={to}
      activeClassName={activeClassName}
      className={`cursor-pointer flex border-primary ${className} opacity-50`}
      exact={exact}
    >
      {
        icon &&
        <div className="hidden lg:block mr-2">
          {icon}
        </div>
      }
      <p className={`whitespace-no-wrap font-bold text-center lg:text-left ${embed ? 'text-xs' : 'text-sm'} ${small ? 'lg:text-sm' : 'lg:text-base'} ${accented} ${uppercaseClass}`}>
        {text}
      </p>
    </NavLink>
  )
}

const DashboardSubNavs = ({links, className}) => {
  const { isDesktop } = useViewport()
  const fallbackClassName = 'mb-10'

  return isDesktop ? (
    <div className={`flex border-b overflow-x-auto ${className ? className : fallbackClassName}`}>
      {
        links.map((t, index) => {
          const className = index === 0 ? '' : 'ml-5'
          return <NavItem
            key={index}
            to={t.route}
            text={t.label}
            className={`pb-4 ${className}`}
            small
            exact={t.exact}
          />
        })
      }
    </div>
  ) : (
    <div className={`flex border-b mb-8 w-full overflow-x-auto ${className}`}>
      {
        links.map((t, index) => {
          return <NavItem
            key={index}
            to={t.route}
            text={t.label}
            className={`whitespace-no-wrap p-4`}
            embed
            exact={t.exact}
          />
        })
      }
    </div>
  )
}

export { DashboardSubNavs }
